import { takeEvery, call, put } from '@redux-saga/core/effects';
import { getCustomersListData } from 'Actions/getCustomerDataAction';
import axios from 'axios';
import { X_API_KEY } from 'config';
import { getCustomersApi } from 'consents/apis';

export function* watchgetCustomerData(){
    yield takeEvery('GET_CUSTOMER_ACTION',handleGetCustomerData)
}

function* handleGetCustomerData(){
    const Data = yield call(getCustomersDetails)
    yield put(getCustomersListData(Data));
}

const getCustomersDetails = async() =>{
    try {
        const token = localStorage.getItem('token');
        const CustomerDetails = await axios.get(getCustomersApi,{
            headers:{
                "x-api-key":X_API_KEY,
                ...(token && { "Authorization": token })
            }
        })
        return CustomerDetails.data.data || [];
    }
    catch(err){
        console.error('Failed to fetch customers:', err?.message || err);
        return [];
    }
}